import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { setShowErrorModal } from "./modalSlice";

import { getUrl } from "../../helpers/url";

const companyNumberField = [
  { name: "denmark", field: "CVR Number" },
  { name: "uk", field: "Company Number" },
  { name: "switzerland", field: "Unique Identification Number(UID)" },
  { name: "norway", field: "Organisation Number" },
  { name: "australia", field: "Australian Business Number(ABN)" },
  { name: "finland", field: "Business ID (Y-tunnus)" },
  // ... add more countries and their codes if needed
];

const findFieldByCountryName = (extractedCountry) => {
  for (const entry of companyNumberField) {
    if (entry.name === extractedCountry) {
      return entry.field;
    }
  }
  return "Company Number";
};
const initialState = {
  mappings: {
    loading: false,
    allCountriesMappings: {},
    mappings: {},
    error: "",
  },
  pipedrive: {
    loading: false,
    pdProperties: [],
    error: "",
  },
  //countries: [],
  countries: [
    "denmark",
    "norway",
    "switzerland",
    "finland",
    "australia",
    "uk",
    // "Sweden",
  ],
  selectedCountry: "denmark",
  defaultMappings: {},
  nonDefaultMappings: {},
  searchInput: "",
  searchResults: {},
  vatValue: [],
  pdValue: {},
  storedKey: "",
  editVatValue: [],
  editPdValue: {},
  enableEditing: false,
  deleteMappedItem: "",
  deletePipedriveFields: [],
  isVatSort: undefined,
  isPdSort: undefined,
  isDirty: false,
  isBtnDisabled: false,
  saveModalMessage: {
    denmark:
      "Please map the Company Address and CVR Number fields to proceed further.",
    uk: "Please map the Company Address and Company Number fields to proceed further.",
    switzerland:
      "Please map the Company Address and Unique Identification Number(UID) fields to proceed further.",
    norway:
      "Please map the Company Address and Organisation Number fields to proceed further.",
    australia:
      "Please map the Company Address and Australian Business Number(ABN) fields to proceed further.",
    finland:
      "Please map the Company Address and Business ID (Y-tunnus) fields to proceed further.",
  },
};

/**
 * @description This function is used for getting mappings
 */
export const fetchMappings = createAsyncThunk(
  "mapping/fetchMappings",
  async (companyId, { dispatch }) => {
    try {
      const { data: response } = await axios.get(
        getUrl("REACT_APP_GET_MAPPING_URL"),
        {
          params: {
            id: companyId,
          },
        }
      );
      return response;
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response && error.response.data.message)
        errorMessage = error.response.data.message;
      else errorMessage = error.message;
      dispatch(setShowErrorModal({ message: errorMessage }));
      throw error;
    }
  }
);

export const fetchPdProperties = createAsyncThunk(
  "mapping/fetchPdProperties",
  async (payload, { dispatch }) => {
    try {
      const body = {
        companyId: payload.companyId,
        userId: payload.userId,
      };
      const { data: response } = await axios.post(
        getUrl("REACT_APP_GET_PD_PROPERTIES"),
        body
      );
      return response;
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.message && error.response.data.message)
        errorMessage = error.response.data.message;
      else errorMessage = error.message;
      dispatch(setShowErrorModal({ message: errorMessage }));
      throw error;
    }
  }
);

export const mappingSlice = createSlice({
  name: "mapping",
  initialState,
  reducers: {
    filterDefaultMappings(state) {
      let defaultMappings = {};
      let nonDefaultMappings = {};
      let searchResults = {};
      if (state.mappings.mappings) {
        Object.keys(state.mappings.mappings).forEach((country) => {
          defaultMappings[`${country}`] = {};
          nonDefaultMappings[`${country}`] = {};
          searchResults[`${country}`] = {};
          Object.entries(state.mappings.mappings[country]).filter(
            (mappedRow) => {
              if (mappedRow[1].key === "undefined") {
                nonDefaultMappings[country][mappedRow[0]] = mappedRow[1];
              } else {
                defaultMappings[country][mappedRow[0]] = mappedRow[1];
              }
              return true;
            }
          );
          defaultMappings[`${country}`] = {
            ...defaultMappings[`${country}`],
            ...nonDefaultMappings[`${country}`],
          };
        });
        state.defaultMappings = defaultMappings;
        state.searchResults = searchResults;
      }
    },

    sortVatFields(state) {
      state.isPdSort = undefined;
      if (state.isVatSort === undefined) {
        state.isVatSort = true;
      } else {
        state.isVatSort = !state.isVatSort;
      }
      if (state.isVatSort === true) {
        let asc = {};
        state.countries.forEach((country) => {
          asc[`${country}`] = {};
        });
        Object.entries(
          state.searchInput.length > 1
            ? state.searchResults[state.selectedCountry]
            : state.defaultMappings[state.selectedCountry]
        )
          .sort((first, second) => (first > second ? 1 : -1))
          .forEach((mapping) => {
            asc[state.selectedCountry][mapping[0]] = mapping[1];
          });
        state.searchInput.length > 1
          ? (state.searchResults[state.selectedCountry] =
              asc[state.selectedCountry])
          : (state.defaultMappings[state.selectedCountry] =
              asc[state.selectedCountry]);
      } else {
        let desc = {};
        state.countries.forEach((country) => {
          desc[`${country}`] = {};
        });
        Object.entries(
          state.searchInput.length > 1
            ? state.searchResults[state.selectedCountry]
            : state.defaultMappings[state.selectedCountry]
        )
          .sort((first, second) => (first > second ? -1 : 1))
          .forEach((mapping) => {
            desc[state.selectedCountry][mapping[0]] = mapping[1];
          });
        state.searchInput.length > 1
          ? (state.searchResults[state.selectedCountry] =
              desc[state.selectedCountry])
          : (state.defaultMappings[state.selectedCountry] =
              desc[state.selectedCountry]);
      }
    },

    sortPdFields(state, { payload }) {
      state.isVatSort = undefined;
      if (state.isPdSort === undefined) {
        state.isPdSort = true;
      } else {
        state.isPdSort = !state.isPdSort;
      }
      if (state.isPdSort === true) {
        let asc = {};
        state.countries.forEach((country) => {
          asc[`${country}`] = {};
        });
        payload
          .sort((first, second) =>
            first.keyword.toLowerCase() > second.keyword.toLowerCase() ? 1 : -1
          )
          .forEach((mapping) => {
            asc[state.selectedCountry][mapping.key] =
              state.searchInput.length > 1
                ? state.searchResults[state.selectedCountry][mapping.key]
                : state.defaultMappings[state.selectedCountry][mapping.key];
          });
        state.searchInput.length > 1
          ? (state.searchResults[state.selectedCountry] =
              asc[state.selectedCountry])
          : (state.defaultMappings[state.selectedCountry] =
              asc[state.selectedCountry]);
      } else {
        let desc = {};
        state.countries.forEach((country) => {
          desc[`${country}`] = {};
        });
        payload
          .sort((first, second) =>
            first.keyword.toLowerCase() > second.keyword.toLowerCase() ? -1 : 1
          )
          .forEach((mapping) => {
            desc[state.selectedCountry][mapping.key] =
              state.searchInput.length > 1
                ? state.searchResults[state.selectedCountry][mapping.key]
                : state.defaultMappings[state.selectedCountry][mapping.key];
          });
        state.searchInput.length > 1
          ? (state.searchResults[state.selectedCountry] =
              desc[state.selectedCountry])
          : (state.defaultMappings[state.selectedCountry] =
              desc[state.selectedCountry]);
      }
    },

    deleteNewMapping(state) {
      state.vatValue = [];
      state.pdValue = {};
      state.isDirty = false;
    },

    storeVatValue(state, { payload }) {
      state.vatValue = payload;
    },

    storePdValue(state, { payload }) {
      state.pdValue = payload;
    },

    editMapping(state, { payload }) {
      state.enableEditing = true;
      state.storedKey = payload;
    },

    updateEnableEditing(state, { payload }) {
      state.enableEditing = false;
      state.storedKey = "";
    },

    storeDeleteMappedItem(state, { payload }) {
      state.deleteMappedItem = payload;
    },

    deleteExistingMapping(state) {
      const newMapping = {
        name: "undefined",
        key: "undefined",
        vatFieldDescription:
          state.defaultMappings[state.selectedCountry][state.deleteMappedItem]
            .vatFieldDescription,
        type: state.defaultMappings[state.selectedCountry][
          state.deleteMappedItem
        ].type,
      };
      state.defaultMappings[state.selectedCountry][state.deleteMappedItem] =
        newMapping;
      state.isDirty = true;
    },

    cancelEditMapping(state) {
      state.editVatValue = [];
      state.editPdValue = {};
      state.enableEditing = false;
      state.storedKey = "";
      state.isDirty = false;
    },

    updatePdValue(state, { payload }) {
      Object.entries(state.defaultMappings[state.selectedCountry]).forEach(
        (el) => {
          if (el[0] === payload) {
            state.defaultMappings[state.selectedCountry][el[0]].key =
              state.editPdValue.key;
            state.defaultMappings[state.selectedCountry][el[0]].name =
              state.editPdValue.name;
          }
        }
      );
    },

    resettingValuesAfterEdit(state) {
      state.enableEditing = false;
      state.storedKey = "";
      state.editVatValue = [];
      state.editPdValue = {};
      state.isDirty = true;
    },

    storeEditVatValue(state, { payload }) {
      state.editVatValue = payload;
    },

    storeEditPdValue(state, { payload }) {
      state.editPdValue = payload;
    },

    searchFilter(state, { payload }) {
      state.searchInput = payload.searchValue;
      if (state.searchInput !== "") {
        state.searchResults = payload.filteredData;
      } else {
        state.searchResults = state.defaultMappings;
      }
    },

    storeSelectedCountry(state, { payload }) {
      state.selectedCountry = payload;
      state.searchInput = "";
      state.isVatSort = undefined;
      state.isPdSort = undefined;
      state.enableEditing = false;
      state.storedKey = "";
    },

    updateIsDirty(state, { payload }) {
      state.isDirty = payload;
    },

    validatePdFields(state, { payload }) {
      state.deletePipedriveFields = [];
      const emptyArray = [];
      const newSet = new Set(
        state.pipedrive.pdProperties.map((pdProperty) => pdProperty.key)
      );

      Object.entries(state.defaultMappings[state.selectedCountry]).forEach(
        (mapping) => {
          if (
            mapping[1].key &&
            mapping[1].key !== "undefined" &&
            !newSet.has(mapping[1].key)
          ) {
            emptyArray.push(mapping[1].key);
          }
        }
      );

      state.deletePipedriveFields = emptyArray;
    },

    checkRequiredFields(state, { payload }) {
      const fieldName = findFieldByCountryName(state.selectedCountry);
      if (
        state.defaultMappings[state.selectedCountry]["Company Address"]
          ?.name === "undefined" ||
        state.defaultMappings[state.selectedCountry][fieldName]?.name ===
          "undefined"
      ) {
        state.isBtnDisabled = true;
      } else {
        state.isBtnDisabled = false;
      }
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchMappings.pending, (state, actions) => {
      if (!state.mappings.loading) {
        state.mappings.loading = true;
      }
    });
    builder.addCase(fetchMappings.fulfilled, (state, actions) => {
      if (state.mappings.loading) {
        state.mappings.loading = false;
        state.mappings.mappings = actions.payload.mappings;
        //state.countries = Object.keys(actions.payload.organization);
        state.mappings.error = "";
      }
    });
    builder.addCase(fetchMappings.rejected, (state, actions) => {
      if (state.mappings.loading) {
        state.mappings.loading = false;
        state.mappings.allCountriesMappings = {};
        state.mappings.mappings = {};
        state.mappings.error = actions.error.message ?? "";
      }
    });
    builder.addCase(fetchPdProperties.pending, (state) => {
      if (!state.pipedrive.loading) {
        state.pipedrive.loading = true;
      }
    });
    builder.addCase(fetchPdProperties.fulfilled, (state, actions) => {
      if (state.pipedrive.loading) {
        state.pipedrive.loading = false;
        state.pipedrive.pdProperties = actions.payload;
        state.pipedrive.error = "";
      }
    });
    builder.addCase(fetchPdProperties.rejected, (state, actions) => {
      if (state.pipedrive.loading) {
        state.pipedrive.loading = false;
        state.pipedrive.pdProperties = [];
        state.pipedrive.error = actions.error.message ?? "";
      }
    });
  },
});

export const {
  filterDefaultMappings,
  sortVatFields,
  sortPdFields,
  deleteNewMapping,
  storeVatValue,
  storePdValue,
  editMapping,
  storeDeleteMappedItem,
  deleteExistingMapping,
  cancelEditMapping,
  updateVatValue,
  updatePdValue,
  updatePdAndVatValue,
  resettingValuesAfterEdit,
  storeEditVatValue,
  storeEditPdValue,
  storeSearchInput,
  searchFilter,
  storeSelectedCountry,
  updateIsDirty,
  validatePdFields,
  checkRequiredFields,
  updateEnableEditing,
} = mappingSlice.actions;

export default mappingSlice.reducer;
